const getParam = (query: URLSearchParams | any, paramName: string) => {
  if (query instanceof URLSearchParams) {
    return query.get(paramName);
  }
  return query[paramName];
};

const parseCategoryPageParams = (query: URLSearchParams | any) => {
  let filters = {};
  try {
    filters = JSON.parse(decodeURIComponent(getParam(query, 'filters') || ''));
  } catch {
    filters = {};
  }

  return {
    pageNr: getParam(query, 'pageNr'),
    sortBy: getParam(query, 'sortBy'),
    filters,
  };
};

export default parseCategoryPageParams;
